import { IconType } from "react-icons";
import { SessionState, SessionType } from "../types/session.entity";
import { FaVideo, FaCalendarAlt, FaUsers } from "react-icons/fa";
import {
  FiClock as Clock,
  FiActivity as Activity,
  FiAlertCircle as AlertCircle,
  FiCheckCircle as CheckCircle,
  FiSlash as Slash,
  FiMinusCircle as MinusCircle,
} from "react-icons/fi";

export const sessionTypeStyles: Record<SessionType, string> = {
  DIRECT: "bg-blue-50   text-blue-700   border border-blue-100", // 1-to-1 direct sessions
  BOOKING: "bg-purple-50 text-purple-700 border border-purple-100", // Scheduled/booked sessions
  LOUNGE: "bg-teal-50   text-teal-700   border border-teal-100", // Group/room-based sessions
};

export const sessionStateStyles: Record<SessionState, string> = {
  STANDBY: "bg-amber-50  text-amber-700  border border-amber-100", // Waiting to start
  REJECTED: "bg-red-50    text-red-700    border border-red-100", // Declined
  MISSED: "bg-orange-50 text-orange-700 border border-orange-100", // No-show
  ACTIVE: "bg-green-50  text-green-700  border border-green-100", // Ongoing
  COMPLETED: "bg-blue-50   text-blue-700   border border-blue-100", // Finished successfully
  CANCELLED: "bg-gray-50   text-gray-700   border border-gray-100", // Stopped before completion
};

export const sessionTypeIcons: Record<SessionType, IconType> = {
  DIRECT: FaVideo,
  BOOKING: FaCalendarAlt,
  LOUNGE: FaUsers,
};

export const sessionStateIcons: Record<SessionState, IconType> = {
  ACTIVE: Activity,
  COMPLETED: CheckCircle,
  CANCELLED: MinusCircle,
  REJECTED: Slash,
  MISSED: AlertCircle,
  STANDBY: Clock,
};
